import { render, staticRenderFns } from "./CustomInstructions.vue?vue&type=template&id=23afb2f7&scoped=true"
import script from "./CustomInstructions.vue?vue&type=script&lang=js"
export * from "./CustomInstructions.vue?vue&type=script&lang=js"
import style0 from "./CustomInstructions.vue?vue&type=style&index=0&id=23afb2f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23afb2f7",
  null
  
)

export default component.exports